import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PALISIS_URL } from "@/lib/site";

export default function CtaBand() {
  return (
    <section className="relative overflow-hidden bg-[#f8b818] py-16 sm:py-20" data-testid="cta-band">
      <div className="absolute -left-16 -top-16 h-64 w-64 rounded-full bg-[#f9c92e] blur-3xl" aria-hidden="true" />
      <div className="absolute -right-10 bottom-0 h-52 w-52 rounded-full bg-[#f9ca47]/60 blur-2xl" aria-hidden="true" />
      <div className="absolute left-1/2 top-0 h-40 w-40 rounded-full bg-[#93cfe8]/35 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-8 px-4 sm:px-6">
        <div>
          <h2 className="text-4xl text-[#0a0a0b] sm:text-5xl" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }} data-testid="cta-band-title">
            READY, SET, GO!
          </h2>
        </div>
        <div className="flex flex-wrap gap-3">
          <a
            href={PALISIS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold !bg-[#0a0a0b] !text-[#f8b818] hover:!bg-[#1c1c1f]"
            data-testid="cta-band-buy-btn"
          >
            Buy Tickets
          </a>
          <Link
            to="/times"
            className="btn-outline !border-[#0a0a0b]/30 !text-[#0a0a0b] hover:!border-[#0a0a0b] hover:!text-[#0a0a0b]"
            data-testid="cta-band-visit-link"
          >
            Plan your visit <ArrowUpRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}
